import { defaultOrder, defaultPage, defaultPageSize } from "src/constants/defaults";
import { Order } from "./order";

export interface IPaged {
	page: number;
	pageSize: number;
	order: Order;
}

export abstract class Paged implements IPaged {
	constructor(
		public page = defaultPage,
		public pageSize = defaultPageSize,
		public order = defaultOrder,
	) { }
}